export default __webpack_public_path__ + "4d8b4db5d29ed522c6de42e9b111b97d.png";